import React from "react";
import { Input } from "../../ui/Input";
import { RadioGroup } from "../../ui/RadioGroup";
import { yesNoOption } from "../../options/options";

export const SovereignWealthFundsForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {
    return (
        <>
            <Input
                label={"Full Name of Sovereign Wealth Fund"}
                name={"uboSovereignWealthFundName"}
                value={formData.uboSovereignWealthFundName}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input
                label={"Name of National Government"}
                name={"uboNationalGovernment"}
                value={formData.uboNationalGovernment}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            <Input 
                label={"Nature/Purpose"}
                name={"uboNature"}
                value={formData.uboNature}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <Input 
                label={"Name of Senior Manager"}
                placeholder={"Senior Manager responsible for the Sovereign Wealth Fund"}
                value={formData.uboSeniorManager}
                name={"uboSeniorManager"}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <RadioGroup 
                label={"Is the Sovereign Wealth Fund a member of the International Working Group?"}
                name={"uboIsMember"}
                value={formData.uboIsMember}
                disabled={isReadOnly}
                onChange={onChange}
                options={yesNoOption}
                isReport={isReport}
            />

        </>
    );
});